import * as React from 'react'; 
import styled from 'styled-components';

interface IProps {
  children?: React.ReactNode;
}

const PaneFooter = (props: IProps) => {
  return (
    <Wrapper>
      {props.children}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: ${p => p.theme.colors.primary[4]};
`

export { PaneFooter }
